import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-200/80 border-t border-background-200/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="py-10 md:py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-primary-500"></i>
              </div>
              <span className="text-base font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
                43423漫画网
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              免费高清漫画在线阅读平台，提供<strong>下拉式漫画</strong>阅读体验。无需下载注册，随时随地畅享精彩漫画。涵盖热血、恋爱、玄幻等多种类型。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">热门分类</h4>
            <div className="flex flex-wrap gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-xs px-3 py-1.5 rounded-full bg-background-50 text-foreground-600 hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/rexue" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">分类浏览</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">联系方式</h4>
            <ul className="space-y-2 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </span>
                support@43423mh.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-customer-service-line text-sm"></i>
                </span>
                在线客服：工作日 9:00-18:00
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 43423漫画网 版权所有 | <strong>家教老师漫画免费阅读</strong>
          </p>
          <p className="text-xs text-foreground-400">
            本站所有漫画均来自互联网，仅供交流学习使用
          </p>
        </div>
      </div>
    </footer>
  );
}